import { IOHOST } from '@/config/config'

// 上报sem数据
export const reporteSemdData = data => {
  return window.$http({
    url: `${IOHOST}/v1/sem_upload_data`,
    method: 'POST',
    Authorization:true,
    data
  })
}